// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

export enum RewriteAction {
    SHORTEN = 'shorten',
    ELABORATE = 'elaborate',
    IMPROVE_WRITING = 'improve_writing',
    FIX_SPELLING = 'fix_spelling',
    SIMPLIFY = 'simplify',
    SUMMARIZE = 'summarize',
    CUSTOM = 'custom',
}
